import script from "./Software.vue?vue&type=script&setup=true&lang=js"
export * from "./Software.vue?vue&type=script&setup=true&lang=js"

import "./Software.vue?vue&type=style&index=0&id=36985357&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36985357"]])

export default __exports__